<template>
    <div>
        <h2>在庫一覧</h2>

        <!-- エントリー一覧表示 -->
        <h3>在庫一覧</h3>
        <v-data-table
            :headers="headers"
            :items="stocks"
            class="elevation-1"
            no-data-text="データはありません"
        >
            <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click="goRegisterExit(item)"
                        >
                        mdi-folder-arrow-right
                        </v-icon>
                    </template>
                    <span>出庫する</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <h3>本店の在庫一覧</h3>
        <v-data-table
            :headers="headers"
            :items="main_store_stocks"
            class="elevation-1"
            no-data-text="データはありません"
        >
        </v-data-table>

    </div>
</template>

<script>
export default {
    data() {
        return {
            menu: false,
            headers: [
                { text: 'カード名', value: 'card.card_name' },
                { text: '色', value: 'card.color' },
                { text: '収録弾', value: 'card.lot' },
                { text: 'カードの状態', value: 'condition' },
                { text: '在庫数', value: 'stock_quantity' },
                { value: 'actions' },
            ],
            stocks: [],
            main_store_stocks: [],
        }
    },
    methods: {
        goRegisterExit(entry) {
            this.$router.push({
                name: 'SelectEntry',
                params: {
                    card_id: entry.card.id,
                    condition: entry.condition,
                    stock_quantity: entry.stock_quantity
                }
            })
        },
    },
    mounted: function () {
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/entry/stock-quantity`, {
            params: { account_id: this.$store.getters.getStoreId }
        })
        .then(res => {
            this.stocks = res.data
        })
        .catch(() => {
            alert(e)
        })

        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/entry/stock-quantity`)
        .then(res => {
            this.main_store_stocks = res.data
        })
        .catch(() => {
            alert(e)
        })
    }
}
</script>
